"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _UITable = _interopRequireDefault(require("UIComponents/table/UITable"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedReactMessage = _interopRequireDefault(require("I18n/components/FormattedReactMessage"));

var _FormattedNumber = _interopRequireDefault(require("I18n/components/FormattedNumber"));

var EmailSendsLimit = function EmailSendsLimit(_ref) {
  var marketingContactsSelected = _ref.marketingContactsSelected,
      emailSendsMultiplier = _ref.emailSendsMultiplier;
  return _react.default.createElement(_UITable.default, null, _react.default.createElement("thead", null, _react.default.createElement("tr", null, _react.default.createElement("th", {
    className: "text-left"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "contactTierPricingModal.marketingContacts.emailSends"
  })), _react.default.createElement("th", {
    className: "text-right"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "contactTierPricingModal.marketingContacts.renews"
  })))), _react.default.createElement("tbody", null, _react.default.createElement("tr", null, _react.default.createElement("td", {
    className: "text-left"
  }, _react.default.createElement(_FormattedReactMessage.default, {
    message: "contactTierPricingModal.marketingContacts.emailSendsAmount",
    options: {
      amount: _react.default.createElement(_FormattedNumber.default, {
        value: marketingContactsSelected * emailSendsMultiplier
      }),
      multiplier: emailSendsMultiplier
    }
  })), _react.default.createElement("td", {
    className: "text-right"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "contactTierPricingModal.marketingContacts.monthly"
  })))));
};

EmailSendsLimit.propTypes = {
  marketingContactsSelected: _propTypes.default.number.isRequired,
  emailSendsMultiplier: _propTypes.default.number.isRequired
};
var _default = EmailSendsLimit;
exports.default = _default;
module.exports = exports.default;